module.exports = __webpack_public_path__ + "images/icon_rightchevron2.svg";